import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePatientDocuments = (patientId, documentType, { enabled = true } = {}) => {
  const tenant = localStorage.getItem("kinesin-tenant");

  const fetchPatientDocuments = async () => {
    if (!patientId) return [];

    const axiosInstance = createAxiosInstance();
    const baseUrl = `${tenant}/document/getbypatientid/${patientId}`;
    const url = documentType ? `${baseUrl}/type/${documentType}` : baseUrl;

    const response = await axiosInstance.get(url);
    return response.data || [];
  };

  return useQuery({
    queryKey: ["patientDocuments", patientId, documentType],
    queryFn: fetchPatientDocuments,
    enabled: !!patientId && enabled,
    staleTime: 30000,
  });
};
